import React, { useCallback, useRef, useState } from 'react';

const ACCEPT = 'image/png,image/jpeg,image/jpg,image/webp,image/avif';

const UploadDropzone = ({ label = 'Imagem', onFileSelected, previewUrl, progress = 0 }) => {
  const [isDragging, setIsDragging] = useState(false);
  const inputRef = useRef(null);

  const handleFiles = useCallback((files) => {
    const file = files?.[0];
    if (!file) return;
    onFileSelected?.(file);
  }, [onFileSelected]);

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    handleFiles(e.dataTransfer.files);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const onDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label} (png, jpg, jpeg, webp, avif)</label>
      <div
        className={[
          'w-full border-2 border-dashed rounded-lg p-4 transition-colors text-center cursor-pointer',
          isDragging ? 'border-[#D67441] bg-[#D67441]/5' : 'border-gray-300 hover:border-[#D67441]'
        ].join(' ')}
        onClick={() => inputRef.current?.click()}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
      >
        <input
          ref={inputRef}
          type="file"
          accept={ACCEPT}
          className="hidden"
          onChange={(e) => handleFiles(e.target.files)}
        />
        <div className="text-xs text-gray-500">
          Arraste a imagem aqui ou clique para selecionar
        </div>
        <div className="mt-3 flex items-center gap-3 justify-center">
          {previewUrl && (
            <img src={previewUrl} alt="Preview" className="w-24 h-16 object-cover rounded border" />
          )}
        </div>
        {progress > 0 && progress < 100 && (
          <div className="mt-3 h-2 bg-gray-200 rounded">
            <div className="h-2 bg-[#D67441] rounded" style={{ width: `${progress}%` }}></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadDropzone; 